import { createContext } from 'react'

interface FormFieldControl {
  htmlFor: string
  messageId?: string
  error: boolean
  required?: boolean
  disabled?: boolean
}

export const FormFieldContext = createContext<FormFieldControl | undefined>(
  undefined
)
